
const Layout = ({ children }) => {

  return (<div className="relative overflow-hidden">
    <main>{children}</main>
  </div>)
}

export default Layout;